// Types
import { sleep } from "@/utils.js";
import { client } from "@/api/client";

export const START_TUTORIAL = "START_TUTORIAL";
export const SET_STEP = "SET_STEP";
export const SEND_TUTORIAL_ACTION = "SEND_TUTORIAL_ACTION";

const OPEN_ACCOUNT = 'OPEN_ACCOUNT'
const SELECT_CONNECTOR_TYPE = 'SELECT_CONNECTOR_TYPE'
const SET_CONNECTOR_TYPE = 'SET_CONNECTOR_TYPE'
const SET_PROGRAMS = 'SET_PROGRAMS';
const SET_EXE_LINK = 'SET_EXE_LINK';
const SET_HOW_MEET_US_ITEMS = 'SET_HOW_MEET_US_ITEMS';

export const ACTIONS = {
    OPEN_ACCOUNT,
    SELECT_CONNECTOR_TYPE,
    SET_CONNECTOR_TYPE,
}

// models
class Tutorial {
    constructor() {
        this.inProgress = false;
        this.numStep = undefined;
        this.action = undefined;
        // specific view attributes
        this.connectorType = undefined;
        this.programs = [];
        this.how_meet_us_items = [];
    }
}

const models = {
    Tutorial,
};

// initial state
const state = () => ({
    inProgress: false,
    numStep: undefined,
    action: undefined,
    connectorType: undefined,
    programs: [],
    exe_link: '',
    how_meet_us_items: [],
})

// getters
const getters = {
    inProgress: state => state.inProgress,
    numStep: state => state.numStep,
    onAction: state => state.action,
    connectorType: state => state.connectorType,
    programs: state => state.programs,
    exe_link: state => state.exe_link,
    how_meet_us_items: state => state.how_meet_us_items,
}

const startTutorial = ({ commit }) => {
    commit(START_TUTORIAL);
}

const setCurrentStep = ({ commit }, numStep) => {
    commit(SET_STEP, numStep);
}

const sendTutorialAction = async ({ commit }, action) => {
    commit(SEND_TUTORIAL_ACTION, undefined);
    await sleep(1)
    commit(SEND_TUTORIAL_ACTION, action);
}

const tutorialSetConnectorType = ({ commit }, connectorType) => {
    commit(SET_CONNECTOR_TYPE, connectorType);
}

const setPrograms = async ({ commit }) => {
    let response = await client.get('programs/?limit=1000');
    commit(SET_PROGRAMS, response.data.results);
}

const setExeLink = async ({ commit}, startWith) => {
    let url = 'python_files/?limit=1&version__startswith=';
    if (startWith) {
        url += startWith;
    } else {
        url += 'INMAPP32';
    }
    let response = await client.get(url);
    if (response.data && response.data.results && response.data.results[0]) {
        commit(SET_EXE_LINK, response.data.results[0]['python_exe']);
    }
}

const setHowMeetUsItems = async ({ commit }) => {
    let response = await client.get('get_how_meet_us_choices/');
    commit(SET_HOW_MEET_US_ITEMS, response.data['choices']);
}

const actions = {
    startTutorial,
    setCurrentStep,
    sendTutorialAction,
    tutorialSetConnectorType,
    setPrograms,
    setExeLink,
    setHowMeetUsItems,
}

// mutations
const mutations = {
    [START_TUTORIAL](state) {
        state.inProgress = true;
    },
    [SET_STEP](state, numStep) {
        state.numStep = numStep;
    },
    [SEND_TUTORIAL_ACTION](state, action) {
        state.action = action;
    },
    [SET_CONNECTOR_TYPE](state, connectorType) {
        state.connectorType = connectorType;
    },
    [SET_PROGRAMS](state, programs) {
        state.programs = programs;
    },
    [SET_EXE_LINK](state, exe_link) {
        state.exe_link = exe_link;
    },
    [SET_HOW_MEET_US_ITEMS](state, items) {
        state.how_meet_us_items = items;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    models,
}
